import type { SVGProps } from "react";
export interface Calculator02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Calculator02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Calculator02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M12 16.875a1.125 1.125 0 0 1 0 2.25H8a1.125 1.125 0 0 1 0-2.25zm8-12a1.125 1.125 0 0 1 0 2.25H4a1.125 1.125 0 0 1 0-2.25zM17.375 18a1.376 1.376 0 0 1-2.743.14l-.008-.14.008-.14A1.376 1.376 0 0 1 16 16.624l.14.007c.694.07 1.235.656 1.235 1.368Zm-8-4a1.375 1.375 0 0 1-2.743.14L6.625 14l.007-.141A1.375 1.375 0 0 1 8 12.626l.141.007c.693.07 1.233.655 1.234 1.367m4 0a1.376 1.376 0 0 1-2.742.14l-.007-.14.007-.141A1.374 1.374 0 0 1 12 12.626l.14.007c.694.07 1.235.655 1.235 1.367m4 0a1.376 1.376 0 0 1-2.743.14l-.008-.14.008-.141A1.375 1.375 0 0 1 16 12.626l.14.007c.694.07 1.235.655 1.235 1.367m-8-4a1.374 1.374 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 8 8.625l.141.007a1.377 1.377 0 0 1 1.234 1.369Zm4 0a1.375 1.375 0 0 1-2.742.141l-.007-.14.007-.141A1.375 1.375 0 0 1 12 8.625l.14.007c.694.07 1.235.656 1.235 1.369Zm4 0a1.375 1.375 0 0 1-2.743.141l-.008-.14.008-.141A1.375 1.375 0 0 1 16 8.625l.14.007c.694.07 1.235.657 1.235 1.369Z"
      />
      <path
        fill={color}
        d="M18.875 5c0-1.035-.84-1.875-1.875-1.875H7c-1.036 0-1.875.84-1.875 1.875v14c0 1.035.84 1.875 1.875 1.875h10c1.036 0 1.875-.84 1.875-1.875zm2.25 14A4.125 4.125 0 0 1 17 23.125H7A4.125 4.125 0 0 1 2.875 19V5A4.125 4.125 0 0 1 7 .875h10A4.125 4.125 0 0 1 21.125 5z"
      />
    </svg>
  );
}
